import {API_MODULES, API_ROUTES, API_SOLUTIONS, ApiRoute} from "@api/ApiRoutes";
import {generateApiEndpoint} from "@api/ApiUtils";
import {Wallet} from "@lib/Wallet/WalletModels";
import {getRequest} from "@api/ApiService";

const ROUTES: Record<string, ApiRoute> = {
    GET_BALANCES: {
        path: API_ROUTES.GET_BALANCES,
        module: API_MODULES.CORE_WALLET,
        solution: API_SOLUTIONS.MZ
    }
}

class WalletService {

    static getBalance = async (): Promise<Wallet | null> => {
        const url = generateApiEndpoint(ROUTES.GET_BALANCES);

        const wallets = await getRequest<Wallet[]>(url);

        return wallets.find(w => w.cmsConfig?.isVisible) ?? null;

        // const mainWallet = wallets.find(w => w.cmsConfig?.isVisible) ?? null;
        //
        // return mainWallet ? {...mainWallet, number: 876100} : null;
    }

}

export default WalletService;